import { api } from "./configs/axiosConfigs"

export const CartolaAPI = {
    get: async (data?: object) => {
        const response = await api.get(
            '/cartola', { params: data }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getExcel: async (data: object) => {
        const response = await api.get(
            '/cartola/excel', { params: data }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getPDF: async (data: object) => {
        const response = await api.get(
            '/cartola/pdf', { params: data }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },
}